import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import Pagination from 'react-js-pagination'

import Filters from '../components/Academies/Filters'
import List from '../components/Academies/List'
import AxiosFetcher from '../components/axiosFetcher'
import { initGA, event } from '../components/analytics'

import { isMobile } from 'react-device-detect'

import i18n from '../i18n';

class Academies extends Component {
  constructor(props){
    super(props);

    this.state = {
      keyword: undefined,
      pagination: { currentPage: 1 }
    }
  }

  componentDidMount() {
    initGA()
  }

  componentDidUpdate(_prevProps, prevState) {
    if (
      this.state.keyword !== prevState.keyword &&
      this.state.pagination.currentPage !== 1
    ) {
      this.handlePageChange(1)
    }
  }

  updateKeywordState(e) {
    const keyword = e.target.value
    this.setState({ keyword })

    if(keyword.length >= 3) {
      event("Registered Academies", "Academy Search", keyword)
    }
  }

  handlePageChange(pageNumber) {
    this.setState({ pagination: { currentPage: pageNumber } })
  }

  render() {
    return (
      <React.Fragment>
        <div className="container">
          <Filters
            keywordField={this.state.keyword}
            updateKeywordState={this.updateKeywordState.bind(this)}
            i18n={i18n}
          />

          <section className="disclaimer pb-4">{i18n.t("academies.listDisclaimer")}</section>

          <AxiosFetcher
            url={`/api/v1/academies/list.json?page=${this.state.pagination.currentPage}`}
            params={{ keyword: this.state.keyword }}
          >
            {({
              loading,
              error,
              data: { list = [], pagination = {} } = {}
            }) => {
              return (
                <React.Fragment>
                  <section className="row academies-list no-gutters">
                    <div className="col-12">
                      <List
                        academies={list}
                        loading={loading}
                        error={error}
                        i18n={i18n}
                        page={this.state.pagination.currentPage}
                      />
                    </div>
                  </section>

                  <section className="row pagination-container no-gutters py-4">
                    <div className="col-12">
                      {list.length && pagination ? (
                        <React.Fragment>
                          <div className="totalizer">
                            <span className="from">
                              {pagination.from == 0
                                ? pagination.from + 1
                                : pagination.from}
                            </span>
                            <span>{` ${i18n.t("pagination.to")} `}</span>
                            <span className="to">{pagination.to}</span>
                            <span>{` ${i18n.t("pagination.of")} `}</span>
                            <span className="totals">
                              {pagination.totalRecords}
                            </span>
                            <span>{` ${i18n.t("academies.componentName")}`}</span>
                          </div>

                          <Pagination
                            activePage={this.state.pagination.currentPage}
                            itemsCountPerPage={pagination.pageSize}
                            totalItemsCount={pagination.totalRecords}
                            pageRangeDisplayed={isMobile ? 3 : 5}
                            onChange={this.handlePageChange.bind(this)}
                            prevPageText={i18n.t("pagination.previous")}
                            nextPageText={i18n.t("pagination.next")}
                            hideFirstLastPages={true}
                            itemClassNext={"next-page"}
                            itemClassPrev={"prev-page"}
                          />
                        </React.Fragment>
                      ) : null}
                    </div>
                  </section>
                </React.Fragment>
              );
            }}
          </AxiosFetcher>

          <section className="disclaimer pb-4">
            <p>{i18n.t("academies.infoUseDisclaimer.firstParagraph")}</p>
            <p>{i18n.t("academies.infoUseDisclaimer.secondParagraph")}</p>
            <p>{i18n.t("academies.infoUseDisclaimer.thirdParagraph")}</p>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

Academies.propTypes = {
  keyword: PropTypes.string,
  pagination: PropTypes.shape({
    currentPage: PropTypes.number
  })
}

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <Academies />,
    document.querySelector('#academies')
  )
});
